module.exports = __webpack_public_path__ + "static/img/2.b1d2f84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/2.jpg
// module id = QlXb
// module chunks = 1